import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { HubOverviewFacade } from './hub-overview.facade';
import { HubItemFacade } from '../hub-item.facade';
import { switchMap } from 'rxjs/operators';
import { checkStoreState, setInitialStoreState } from '../../../../../../common/utils';

@Injectable({
  providedIn: 'root',
})
export class HubOverviewGuard {
  constructor(private hubItemFacade: HubItemFacade, private hubOverviewFacade: HubOverviewFacade) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return this.hubItemFacade.hubId$.pipe(switchMap((hubId: number) => checkStoreState(this.hubOverviewFacade, hubId)));
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.hubOverviewFacade);
  }
}
